import { CrossStorageClient } from "cross-storage"
import benefitInsuranceStore from "stores/benefitInsuranceStore"
import { backofficeEnv } from "env"

/** Runs after first paint so it does not compete with JS chunk download / parse. */
export function scheduleCrossStorageBenefitSync(): void {
  const run = () => {
    const storageClient = new CrossStorageClient(`${backofficeEnv.HOST}`, {})

    storageClient
      .onConnect()
      .then(() => storageClient.get("CROSS_STORAGE_DATA"))
      .then((value: unknown) => {
        if (value == null) return
        const benefitInsurance = typeof value === "string" ? JSON.parse(value) : value
        const newBenefitInsurance = JSON.parse(JSON.stringify(benefitInsurance))
        benefitInsuranceStore.initialPreviewBenefitInsurance(newBenefitInsurance)
      })
      .catch((error: unknown) => {
        console.log("Error retrieving value:", error)
      })
  }

  if (typeof window !== "undefined" && "requestIdleCallback" in window) {
    window.requestIdleCallback(() => run(), { timeout: 3000 })
  } else {
    setTimeout(run, 0)
  }
}
